import { get, writable } from 'svelte/store'

const theme = writable<Theme>(localStorage.getItem('theme') as Theme || 'system')

const setWindowDarkMode = (enabled: boolean) => {
  if (enabled) {
    document.documentElement.classList.add('dark')
  }
  else {
    document.documentElement.classList.remove('dark')
  }
}

window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', ({ matches }) => {
    const selectedTheme = get(theme)
    if (!selectedTheme || selectedTheme === 'system') {
      setWindowDarkMode(matches)
    }
  })

const useTheme = () => {
  function setTheme(newTheme: Theme) {
    theme.update(() => newTheme)
  }

  theme.subscribe((value) => {
    localStorage.setItem('theme', value)
    switch (value) {
      case 'dark':
        setWindowDarkMode(true)
        break
      case 'light':
        setWindowDarkMode(false)
        break
      case 'system':
        setWindowDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches)
        break
    }
  })

  return {
    theme,
    setTheme,
  }
}

export default useTheme
